import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const defaultProps = {
  className: '',
  onClick: () => {},
  selected: false,
  value: '',
};

const PaginateItem = ({ className, onClick, selected, value }) => {
  const classNames = cx(className, {
    selected,
  });

  return <a className={classNames} onClick={onClick}>{value}</a>;
};

PaginateItem.propTypes = propTypes;
PaginateItem.defaultProps = defaultProps;

export default PaginateItem;
